module.exports = __webpack_public_path__ + "static/img/item7.a566e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item7.png
// module id = mWsv
// module chunks = 0